import AdminFaxSearchResults from './admin-fax-search-results-component';

import './admin-fax-search-results.scss';

const MODULE_NAME = 'App.admin.fax.results';
const module = angular.module(MODULE_NAME, [])
    .directive(AdminFaxSearchResults.DIRECTIVE_NAME, AdminFaxSearchResults);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-search-results/admin-fax-search-results-module.js